<template>
  <div class="topbar">
    <!-- <div class="footerli hover" v-on:click="gotoHomePage()" v-if="hover==1">首页 -->
    <div class="titleimg">
      <img src="~assets/images/head/head1.jpg" alt="" />
    </div>
    <div class="titlebar">
      <div class="logoimg">
        <img src="~assets/images/head/logo3.png" alt="" />
      </div>
      　
      <div class="titlenav">
        <div class="navitem" v-on:click="gotoHomePage()">
          <a href="javascript:void(0)">Home</a>
        </div>
        <!-- <div class="footerpaddig">|</div> -->
        <div class="navitem">
          <a href="javascript:void(0)" @click="gotoRegTiePage">百万铁人</a>
        </div>
        <!-- <div class="footerpaddig">|</div> -->
        <div class="navitem">
          <a href="javascript:void(0)" @click="gotoClublist">俱乐部</a>
        </div>
        <div class="navitem">
          <a href="javascript:void(0)" @click="gotoRacelist">赛事</a>
        </div>
        <div class="navitem">
          <a href="javascript:void(0)" @click="gotoShoplist">装备</a>
        </div>
        <!-- <div class="footerpaddig">|</div> -->
        <div class="navitem">
          <a href="javascript:void(0)" @click="gotoCourselist">课程</a>
        </div>
        <div class="navitem">
          <a href="javascript:void(0)" @click="gotoAbout">联系我们</a>
          </div>
      </div>
      　
      <div class="navRegitem">
        <a href="javascript:void(0)" @click="gotoMyPage" v-if="!isShowLoginBtn"
          >个人中心</a
        >
        <a href="javascript:void(0)" @click="gotoRegPage" v-if="isShowLoginBtn">
          登录/注册</a
        >
      </div>
      　
      <div class="personbox">
        <img src="~assets/images/head/person.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"; // 导入 Axios

export default {
  name: "MyHead",
  // props: {
  //   'hover':{
  //   type: Number,
  //   required : true
  //   }
  // },
  data() {
    return {
      token: "",
      response: null,
      error: null,
      isShowLoginBtn: true,
    };
  },
  components: {},
  computed: {},
  mounted: function () {
    this.token = localStorage.getItem("token");
    // console.log(this.token);
    if (this.token) {
      this.CheckUserbtn();
    }
  },
  methods: {
    gotoRegTiePage: function () {
      this.$router.push({
        name: "regTiePage",
      });
    },
    gotoHomePage: function () {
      this.$router.push({
        name: "Index",
      });
    },
    gotoMyPage: function () {
      this.$router.push({
        name: "Myselfpage",
      });
    },
    gotoSetPage: function () {
      this.$router.push({
        name: "Setpage",
      });
    },
    gotoRankPage: function () {
      this.$router.push({
        name: "orderpage",
      });
    },
    gotoShoplist: function () {
      this.$router.push({
        name: "shop",
      });
    },
    gotoRegPage: function () {
      this.$router.push({
        name: "regPage",
      });
    },
    gotoClublist: function () {
      this.$router.push({
        name: "clublist",
      });
    },
    gotoRacelist: function () {
      this.$router.push({
        name: "racelist",
      });
    },
    gotoCourselist: function () {
      this.$router.push({
        name: "courselist",
      });
    },
    gotoAbout: function () {
      this.$router.push({
        name: "about",
      });
    },
    CheckUserbtn: function () {
      this.CheckUserPostRequest();
    },
    async CheckUserPostRequest() {
      // console.log(this.token);
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const url = " https://ttserver.aizhuotice.online/api/v1/userInfo";
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            token: this.token,
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        // console.log(this.response);
        if (this.response.code == 200) {
          console.log("token成功");
          this.isShowLoginBtn = false;
        } else {
          this.isShowLoginBtn = true;
        }
        if (this.response.code == 4011) {
          // alert(this.response.message);
          console.log(this.response.msg);
          this.token = "";
          localStorage.setItem("token", "");
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },
  },
};
</script>

<style scoped>
.topbar {
  width: 100vw;
  height: 11vw;
  background-color: #000;
  position: relative;
}

.topbar .titleimg {
  width: 100vw;
  height: 5vw;
  margin: 0 auto;
}

.topbar .titleimg img {
  width: 100%;
  height: auto;
}

.titlebar {
  margin-top: 1vw;
  width: 100vw;
  height: 5vw;
  display: flex;
  /* justify-content: space-between; */
  /* 让两个 div 之间有间距 */
  /* gap: 20px; */
  /* 可选：设置两个 div 之间的间距 */
  color: #fff;
}

.titlebar .logoimg {
  width: 27vw;
  height: 100%;
  /* position: relative; */
  margin-left: 3vw;
  display: flex;
  margin-top: 0.5vw;
}

.titlebar .logoimg img {
  width: 10vw;
  height: 3.5vw;
}

.titlebar .titlenav {
  width: 38vw;
  height: 100%;
  display: flex;
  /* flex-direction: column; 
  align-items: center; 
  border: 1px solid #ccc; 
  padding: 10px; */
  justify-content: space-around;
  /* 文字之间均匀分布 */
  align-items: center;
  /* 垂直居中对齐 */
  font-weight: bolder;
  font-size: 1.4vw;
}

.titlebar .titlenav .navitem {
  /* width: 100%;
    height: 100%; 
     display: flex; */
  color: #fff;
}

.titlebar .titlenav .navitem:hover {
  /* width: 100%;
    height: 100%; 
     display: flex; */
  color: #aaa;
}

.titlebar .navRegitem {
  margin-left: 11.5vw;
  margin-top: 0.4vw;
  width: 13vw;
  height: 3.5vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: bolder;
  font-size: 1.4vw;
  background-color: #a81f24;
}

.navRegitem a {
  color: #fff;
}

.titlebar .navRegitem:hover {
  color: #000;
}
.titlebar .personbox {
  margin-left: 1.5vw;
  margin-top: 0vw;
  width: 2vw;
  height: 4vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* background-color: #a81f24; */
}

.titlebar .personbox img {
  width: 100%;
  height: auto;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/block/myhead.vue